import * as React from "react";
import { cn } from "utils/cn";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  testId?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, testId, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "flex min-h-[80px] w-full rounded-xl border border-secondary-300 bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-secondary-200 focus-visible:outline-hidden focus:shadow-base disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        data-testid={testId}
        {...props}
      />
    );
  },
);

Textarea.displayName = "Textarea";

export { Textarea };
